import { setElapsedTime, setLotteryTimer } from '@features/LotteryGame';
import { createListenerMiddleware } from '@reduxjs/toolkit';

const listenerMiddleware = createListenerMiddleware();

// Слушатель для управления таймером лотереи
listenerMiddleware.startListening({
  actionCreator: setLotteryTimer,
  effect: async (action, listenerApi) => {
    const { gameId, timer } = action.payload;

    let timerCopy = timer;

    // Цикл работает, пока значение таймера больше нуля
    while (timerCopy !== undefined && timerCopy > 0) {
      await listenerApi.delay(1000);

      timerCopy -= 1;

      listenerApi.dispatch(
        setElapsedTime({
          gameId,
          elapsedTime: timerCopy,
        }),
      );
    }
  },
});

export default listenerMiddleware;
